import React from 'react';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useChat } from '../contexts/ChatContext';
import { colors, typography } from '../config/theme';
import EmployeeHomeScreen from '../screens/employee/EmployeeHomeScreen';
import MyScheduleScreen from '../screens/employee/MyScheduleScreen';
import HelpScreen from '../screens/HelpScreen';
import AiScreen from '../screens/AiScreen';
import ProductExpiriesScreen from '../screens/ProductExpiriesScreen';
import ChatNavigator from './ChatNavigator';

const Tab = createBottomTabNavigator();

export default function EmployeeNavigator() {
  const insets = useSafeAreaInsets();
  const { total } = useChat();
  const bottom = Math.max(insets.bottom, 6);
  return (
    <Tab.Navigator
      screenOptions={{
        headerShown: false,
        tabBarActiveTintColor: colors.primary,
        tabBarInactiveTintColor: colors.textMuted,
        tabBarLabelStyle: { fontFamily: typography.button.fontFamily, fontSize: 12, fontWeight: '800', letterSpacing: 0.2 },
        tabBarIconStyle: { display: 'none' },
        tabBarStyle: { backgroundColor: colors.surface, borderTopColor: colors.border, borderTopWidth: 1, paddingTop: 10, paddingBottom: bottom, height: 54 + bottom },
      }}
    >
      <Tab.Screen name="Shift" component={EmployeeHomeScreen} options={{ tabBarLabel: '🔥 Смена' }} />
      <Tab.Screen name="MySchedule" component={MyScheduleScreen} options={{ tabBarLabel: '📅 График' }} />
      <Tab.Screen name="ProductExpiries" component={ProductExpiriesScreen} options={{ tabBarLabel: '📦 Сроки' }} />
      <Tab.Screen name="Chat" component={ChatNavigator} options={{ tabBarLabel: '💬 Чат', tabBarBadge: total || undefined }} />
      <Tab.Screen name="Assistant" component={AiScreen} options={{ tabBarLabel: '🤖 Помощник' }} />
      <Tab.Screen name="Help" component={HelpScreen} options={{ tabBarLabel: '📖 Памятка' }} />
    </Tab.Navigator>
  );
}
